var p = (t, e, i) => new Promise((s, n) => {
  var f = (o) => {
    try {
      r(i.next(o));
    } catch (a) {
      n(a);
    }
  }, c = (o) => {
    try {
      r(i.throw(o));
    } catch (a) {
      n(a);
    }
  }, r = (o) => o.done ? s(o.value) : Promise.resolve(o.value).then(f, c);
  r((i = i.apply(t, e)).next());
});
import { I as m } from "../icon-51ff7679.js";
import { i as l } from "../util-b2b0dc25.js";
import "vue";
import "../_plugin-vue_export-helper-dad06003.js";
m.install = function(t) {
  return p(this, null, function* () {
    l() || (yield import("../assets/fonts/icon/iconfont.js")), t.component(m.name, m);
  });
};
export {
  m as default
};
